import MaterialTable from "@material-table/core";
import _ from "lodash";
import useFilterState from "../../../hooks/useFilterState";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const AllOrdersMaterialTable = (props) => {
  const providerOrderTable = "AllOrders";
  const { tableName, tableRef, columns, tableData, exportCsv, isInternal } =
    props;

  const [columnsWithFilter, handleFilterChange] = useFilterState(
    tableName,
    columns
  );

  return (
    <div id="all-orders-table" style={{ textAlign: "center", marginTop: "20px" }}>
      {columns.length > 0 ? (
        <MaterialTable
          tableRef={tableRef}
          enablePagination={false}
          localization={{
            body: {
              emptyDataSourceMessage: (
                <h6 className="left-[45%] absolute top-[40%] text-center">
                  No records to display
                </h6>
              ),
            },
            pagination: {
              labelRowsPerPage: "Orders Per Page",
              labelRowsSelect: "Orders",
            },
          }}
          options={{
            rowStyle: {
              fontSize: 8,
              overflowWrap: "break-word",
              height: "40px",
            },
            paging: true,
            pageSize: 100,
            selection: false,
            filtering: true,
            search: false,
            showTitle: false,
            grouping: true,
            maxBodyHeight: 600,
            headerStyle: {
              backgroundColor: "#367c2b",
              fontWeight: "400",
              color: "white",
              fontSize: "10px",
              position: "sticky",
              top: 0,
              zIndex: 10,
            },
            tableContainerStyle: {
              maxHeight: 600,
              overflow: "auto",
            },
            pageSizeOptions: [100, 250, 500, 1000],
            exportCsv: (columns, data) => exportCsv(columns, data),
            filterCellStyle: {
              flex: 1
            },
          }}
          title={providerOrderTable}
          columns={columnsWithFilter.map((col, index) => {
            if (
              col.tableData?.filterValue == "" ||
              col.tableData?.filterValue == null ||
              col.tableData?.filterValue == undefined
            ) {
              let colWithoutDefaultFilter = _.omit(
                col,
                "defaultFilter",
                "tableData.filterValue"
              );
              return colWithoutDefaultFilter;
            } else {
              return {
                ...col,
                defaultFilter: col.tableData?.filterValue,
              };
            }
          })}
          data={tableData}
          onFilterChange={(filters) => {
            // Create a map of current filters for quick lookup
            const filterMap = new Map();
            filters.forEach((filter) => {
              filterMap.set(filter.column.tableData.id, filter.value);
            });

            // Iterate over all columns to ensure each one is checked if the value is present in the filter map
            columns.forEach((col, columnId) => {
              const newValue = filterMap.get(columnId) || ""; // Default to empty string if not found

              // Update the filter state for each column
              handleFilterChange(columnId, newValue);
            });
          }}
        />
      ) : (
        <div className="flex items-center justify-center bg-white h-[600px] border-t-2 border-gray-400 text-xl p-4 rounded-lg">
          {isInternal ? (
            <span>
              <ErrorOutlineIcon className="mr-2 mb-1" /> Please select a
              forwarder
            </span>
          ) : (
            <span>
              <ErrorOutlineIcon className="mr-2 mb-1" /> Please wait..
            </span>
          )}
        </div>
      )}
    </div>
  );
};
export default AllOrdersMaterialTable;
